import { render, staticRenderFns } from "./classEdit.vue?vue&type=template&id=fba8ec30&scoped=true"
import script from "./classEdit.vue?vue&type=script&lang=js"
export * from "./classEdit.vue?vue&type=script&lang=js"
import style0 from "./classEdit.vue?vue&type=style&index=0&id=fba8ec30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba8ec30",
  null
  
)

export default component.exports